<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-tabs default-active-key="全部" v-model="query.status" @change="callback">
        <a-tab-pane key="" tab="全部"></a-tab-pane>
        <a-tab-pane :key="0" tab="未开始"></a-tab-pane>
        <a-tab-pane :key="1" tab="执行中"></a-tab-pane>
        <a-tab-pane :key="2" tab="已提交"></a-tab-pane>
        <a-tab-pane :key="3" tab="已完成"></a-tab-pane>
      </a-tabs>
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="任务名称">
              <a-input v-model="query.taskName" placeholder="请输入任务名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="负责人">
              <a-input v-model="query.principalName" placeholder="请输入负责人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="巡检泵房">
              <a-input v-model="query.pumpName" placeholder="请输入巡检泵房" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="泵房状态">
              <a-select placeholder="请选择泵房状态" v-model="query.pumpStatus">
                <a-select-option value="0">正常</a-select-option>
                <a-select-option value="1">异常</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="9" :sm="12">
            <a-form-item label="预期开始时间">
              <a-range-picker v-model="dates" @change="StartOnChange" />
            </a-form-item>
          </a-col>
          <a-col :md="9" :sm="12">
            <a-form-item label="开始时间">
              <a-range-picker v-model="datet" @change="StartOnChan" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48"> </a-row>
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="PublishTask()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()" v-action:export>导出</a-button>
              <a-button v-if="query.status === 3" type="primary" style="margin-left: 8px" @click="DispatchOrder()"
                >派发工单</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :scroll="{ x: 2100 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <!-- <a v-if="query.status === '' || query.status === 0" @click="editHandle(record)" v-action:edit>编辑</a> -->
        <!-- <a-divider v-if="query.status === '' || query.status === 0" type="vertical" /> -->
        <a @click="goDetails(record.id)">详情</a>
      </span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="processingTime" slot-scope="text" v-if="text !== null">{{ text }}</span>
      <span slot="planTime" slot-scope="text" v-if="text !== null">{{ text }}天</span>
      <template slot="status" slot-scope="text">
        <span v-if="text == 0">
          <a-tag color="rgb(255, 99, 71)"> 未开始 </a-tag>
        </span>
        <span v-else-if="text == 1">
          <a-tag color="#f98303"> 执行中 </a-tag>
        </span>
        <span v-else-if="text == 2">
          <a-tag color="#40a9ff"> 已提交 </a-tag>
        </span>
        <span v-else>
          <a-tag color="rgb(50, 205, 50)"> 已完成 </a-tag>
        </span>
      </template>
      <template slot="pumpStatus" slot-scope="text">
        <span v-if="text == 0">
          <a-tag color="rgb(50, 205, 50)"> 正常 </a-tag>
        </span>
        <span v-else-if="text == 1">
          <a-tag color="rgb(255, 99, 71)"> 异常 </a-tag>
        </span>
      </template>
    </a-table>
    <!-- <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    ></a-modal>-->

    <task-modal ref="TaskModal" @handleOk="queryList"></task-modal>
    <details-modal ref="DetailsModal" @handleOk="queryList"></details-modal>
    <order-modal ref="OrderModal" @handleOk="queryList"></order-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import TaskModal from './modules/TaskModal'
import DetailsModal from './modules/DetailsModal'
import OrderModal from './modules/OrderModal'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },

  {
    title: '任务编号',
    dataIndex: 'taskNumber',
  },
  {
    title: '任务名称',
    dataIndex: 'taskName',
    ellipsis: true,
  },
  {
    title: '巡检泵房',
    dataIndex: 'pumpName',
  },
  {
    title: '任务来源',
    dataIndex: 'origin',
  },
  {
    title: '任务描述',
    dataIndex: 'description',
    ellipsis: true,
  },
  {
    title: '负责人',
    dataIndex: 'principalName',
  },
  {
    title: '预期开始时间',
    dataIndex: 'predictStime',
  },
  {
    title: '预期处理时长',
    dataIndex: 'planTime',
    scopedSlots: { customRender: 'planTime' },
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
  },
  {
    title: '处理时长',
    dataIndex: 'processingTime',
    scopedSlots: { customRender: 'processingTime' },
  },
  {
    title: '任务状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '泵房状态',
    dataIndex: 'pumpStatus',
    scopedSlots: { customRender: 'pumpStatus' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 120,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  components: {
    TaskModal,
    DetailsModal,
    OrderModal,
  },
  name: 'TaskManagement',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/inspection_tasks/page',
      deleteUrl: '/pipe-network/inspection_tasks',
      addOrUpdateUrl: '/pipe-network/inspection_tasks',
      queryOneUrl: '/pipe-network/inspection_tasks',
      exportDataUrl: 'pipe-network/inspection_tasks/export',
      exportFileName: '任务管理数据表.xlsx',
      query: {
        status: '',
        patrolman: '',
        taskNumber: '',
        pumpStatus: '',
        place: '',
        startTime: '',
        endTime: '',
        sysType: '二次供水',
        taskName: '',
        predictStime: '',
        predictEtime: '',
      },
      statu: '',
      dates: [],
      datet: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: {
        eventName: '',
        eventType: '',
        address: '',
        reportPerson: '',
        phone: '',
        reportTime: '',
        eventDescription: '',
        accessorys: [],
        sysType: '二次供水',
      },
      uploadUrl: process.env.VUE_APP_API_BASE_URL + 'manager/file/resources/upload',
      TaskList: [],
      eventTypeList: [],
    }
  },
  filters: {
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  computed: {
    rules() {
      return {}
    },
  },
  created() {
    this.getTaskList()
    this.resetList()
  },
  methods: {
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .delete(_this.deleteUrl, { data: _this.selectedRows })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.selectedRows.length = ''
                console.log(_this.selectedRows.length, 'llll')
                _this.queryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          console.log(_this.selectedRows.length, 'lll')
          _this.$message.info('已取消删除')
        },
      })
    },
    handleMapOk(data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.locationInformation = data.point
      console.log(this.addOrUpdateForm.address)
    },
    resetList() {
      this.query = {
        status: this.statu,
        workOrderType: '',
        deviceName: '',
        deviceNo: '',
        maintainPerson: '',
        sysType: '二次供水',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.dates = []
      this.datet = []
      this.queryList()
    },
    callback(key) {
      this.statu = key
      console.log(key)
      if (key == '全部') {
      } else {
      }
      this.queryList()
    },
    PublishTask() {
      this.$refs.TaskModal.edit()
    },
    editHandle(record) {
      console.log(123)
      this.$refs.TaskModal.edit(record.id)
    },
    goDetails(id) {
      this.$refs.DetailsModal.edit(id)
    },
    DispatchOrder() {
      if (this.selectedRows.length == 1) {
        this.$refs.OrderModal.edit(this.selectedRowsList[0])
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条要派发工单的事件')
      } else {
        return this.$message.warn('只能选择一条要派发工单的事件')
      }
    },
    selectChange(value) {
      this.addOrUpdateForm.accessorys = `${value}`
    },
    getTaskList() {
      const params = {
        dictCode: 'TASK_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        
        this.TaskList = data
      })
    },
    EndOnChange(date, dateString) {
      this.query.endTime = dateString
    },
    StartOnChange(date, dateString) {
      this.query.predictStime = dateString[0]
      this.query.predictEtime = dateString[1]
    },
    StartOnChan(date, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
    },
    detailInfo(record) {
      this.detailForm = { ...record }
    },
    showLineLayer(record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    handleCancel() {},
    onOk(value) {},
  },
  watch: {},
}
</script>

<style lang="less" scoped>
 /deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
